define([
	"dojo/_base/declare",
	"csi/form/Widget",
	"csi"
], function(declare, Widget, csi) {

	var DELEGATION_END_TIME = "DelegationEndTime";
	var DELEGATION_START_TIME = "DelegationStartTime";
	var DELEGATION_USER = "DelegationUser";

	return declare(Widget, {
		// Object: map of required attributes expressions
		_requiredExpressions: {
			DelegationEndTime: "attr('" + DELEGATION_USER + "') != '" + csi.EMPTY_URL + "'",
			DelegationStartTime: "attr('" + DELEGATION_USER + "') != '" + csi.EMPTY_URL + "'"
		},

		getValueForField: function(/*Field*/field, /*Node?*/node) {
			// summary: for time fields, use heading renderer so as to handle time-zone issues
			if (node && (field.m_id == DELEGATION_END_TIME || field.m_id == DELEGATION_START_TIME)) {
				return field.ren._getValue(this.getContext(node.$URL), field.heading);
			}
			return this.inherited(arguments);
		},

		_updateFieldVisibility: function(/*csi.def.Field?*/field) {
			var changed = this.inherited(arguments);
			if (!field || field.m_id == DELEGATION_USER) {
				var noUser = this.defView.getFieldValue(DELEGATION_USER) == csi.EMPTY_URL;
				this.setFieldDisabled(DELEGATION_END_TIME, noUser);
				this.setFieldDisabled(DELEGATION_START_TIME, noUser);
			}
			return changed;
		}
	});
});